import {useState} from "react";
import axios from "axios";
import {ArrowLeftIcon, XMarkIcon} from "@heroicons/react/24/outline";
import toast from "react-hot-toast";

const validityOptions = [
  //   {label: "7 days", value: "7d"},
  //   {label: "2 weeks", value: "2w"},
  //   {label: "1 month", value: "1m"},
  //   {label: "1 year", value: "1y"},
  {label: "45 Days", value: "45d"},
  {label: "90 Days", value: "90d"},
];

export default function AddEditSubscription({
  onClose,
  defaultValues,
  onUpdate,
}: {
  onClose: () => void;
  defaultValues?: any;
  onUpdate: (updatedData: any) => void;
}) {
  const [isLoading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    id: defaultValues?.id || null,
    name: defaultValues?.name || "",
    description: defaultValues?.description || "",
    amount: defaultValues?.amount?.toString() || "",
    validityNumber: "",
    validity: defaultValues?.validity || "",
    validityUnit: "d", // Default to 'd' for days
    allowedDeliveries: defaultValues?.allowedDeliveries?.toString() || "",
  });
  const Baseurl = process.env.REACT_APP_BASEURL;
  const getToken: any = localStorage.getItem("eftd-admin-token");
  const tokenObject: any = JSON.parse(getToken);
  const token = tokenObject?.data?.data?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  // console.log(defaultValues);

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const {name, value} = e.target;
    setFormData((prev) => ({...prev, [name]: value}));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    setLoading(true);

    const payload = {
      name: formData.name,
      description: formData.description,
      amount: Number(formData.amount),
      validity: `${formData.validityNumber}${formData.validityUnit}`,
      allowedDeliveries: String(formData.allowedDeliveries),
    };

    try {
      // const token = JSON.parse(localStorage.getItem("eftd-admin-token") || "{}")?.data?.data?.token;

      let response;
      // Check if formData.id exists to determine if it's an edit operation
      if (formData?.id) {
        // Edit operation: Use PUT method with the ID in the URL
        response = await axios.put(
          `${Baseurl}/api/admin/subscription/editPlan/${formData?.id}`, // Use PUT for edits
          payload,
          config
        );
        toast.success("Plan updated successfully.");
      } else {
        // Create operation: Use POST method
        response = await axios.post(
          `${Baseurl}/api/admin/subscription/createplan`,
          payload,
          config
        );
        toast.success("Plan created successfull.");
      }

      setLoading(false);
      onUpdate(response);
      onClose();
    } catch (err: any) {
      setLoading(false);
      toast.error(`An error occoured`);
      // handle error state / toast here
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="w-full max-w-lg mx-auto p-6 relative overflow-y-auto"
    >
      <button className="flex items-center gap-2 !mb-2" onClick={onClose}>
        <ArrowLeftIcon width={24} height={24} color="#666D80" />
        <p className="!text-sm text-[#666d80]">Go Back</p>
      </button>

      <div className="mb-10">
        <h3 className="!text-[28px] !font-bold !text-[#272835]">
          Add Subscription
        </h3>
        <p className="!text-sm !text-[#818898]">
          Provide details about the sub
        </p>
      </div>

      {/* Title */}
      <div className="flex flex-col gap-1 mb-4">
        <label htmlFor="name" className="text-sm text-gray-800">
          Title
        </label>
        <input
          type="text"
          name="name"
          id="name"
          placeholder="Enter plan title"
          value={formData.name}
          onChange={handleChange}
          className="w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-sm text-gray-900 focus:outline-none"
        />
      </div>

      {/* Description */}
      <div className="flex flex-col gap-1">
        <label htmlFor="description" className="text-sm text-gray-800">
          Description
        </label>
        <textarea
          name="description"
          id="description"
          placeholder="Enter description"
          value={formData.description}
          onChange={handleChange}
          rows={4}
          className="w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-sm text-gray-900 focus:outline-none resize-none"
        ></textarea>
      </div>
      <div className="text-gray-400 text-xs mb-4">
        Hint: This plan has the basic details you need as a user and effective
      </div>

      {/* Amount */}
      <div className="flex flex-col gap-1 mb-4">
        <label htmlFor="amount" className="text-sm text-gray-800">
          Amount (₦)
        </label>
        <input
          type="number"
          name="amount"
          id="amount"
          placeholder="Enter amount"
          value={formData.amount}
          onChange={handleChange}
          className="w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-sm text-gray-900 focus:outline-none"
        />
      </div>

      {/* Validity */}
      <div className="flex flex-col gap-1 mb-4">
        <label htmlFor="validityNumber" className="text-sm text-gray-800">
          Duration
        </label>
        <div className="flex">
          <input
            type="number"
            name="validityNumber"
            id="validityNumber"
            placeholder="Enter number"
            value={formData.validityNumber}
            onChange={handleChange}
            className="w-2/4 rounded-l-lg border border-gray-300 bg-white px-4 py-3 text-sm text-gray-900 focus:outline-none"
          />
          <select
            name="validityUnit"
            id="validityUnit"
            value={formData.validityUnit}
            onChange={handleChange}
            className="w-2/4 rounded-r-lg border border-gray-300 bg-white px-4 py-3 text-sm text-gray-900 focus:outline-none"
          >
            <option value="d">Day(s)</option>
            <option value="w">Week(s)</option>
            <option value="m">Month(s)</option>
            <option value="y">Year(s)</option>
          </select>
        </div>
      </div>
      {/* allowedDeliveries */}
      <div className="flex flex-col gap-1 mb-20">
        <label htmlFor="allowedDeliveries" className="text-sm text-gray-800">
          Allowed Deliveries
        </label>
        <input
          type="number"
          name="allowedDeliveries"
          id="allowedDeliveries"
          placeholder="Enter allowedDeliveries"
          value={formData.allowedDeliveries}
          onChange={handleChange}
          className="w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-sm text-gray-900 focus:outline-none"
        />
      </div>

      <div className="fixed bottom-0 right-0 w-full max-w-md bg-white border-t border-gray-100 px-6 py-4 flex justify-between gap-4">
        <button
          type="button"
          onClick={onClose}
          className="flex-1 py-3 rounded-lg border border-gray-300 text-gray-600 font-semibold hover:bg-gray-100 transition"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="flex-1 py-3 rounded-lg bg-orange-500 text-white font-semibold hover:bg-orange-600 transition"
          disabled={isLoading}
        >
          {isLoading ? "Processing..." : "Submit"}
        </button>
      </div>
    </form>
  );
}
